import { Link } from 'react-router-dom';
import { useRef, useState } from 'react';
import { useEffect } from 'react';
import { ButtonBasic, Checkbox } from "@lk-gtcom/ecomlab-components";
import { TextPage } from '../../TextPage/TextPage';
import settings_icon from './Img/settings.svg'
import "./BtnDropRadio.scss"

const MetricControls = ({ checkboxValues, setCheckboxValues }) => {
    const [selections, setSelections] = useState(checkboxValues);

    const handleRadioChange = (metric, value) => {
        setSelections(prev => ({
            ...prev,
            [metric]: value
        }));
    };

    useEffect(() => {
        setCheckboxValues(selections)
    }, [selections]);

    // Массив всех показателей
    const metrics = ['ставка', 'продажи', 'показы', 'затраты'];
    // Массив всех вариантов выбора
    const options = ['Да', 'Нет', 'Не использовать'];

    return (
        <>

            {/* Генерация групп радиокнопок для каждого показателя */}
            {metrics.map(metric => (
                <div className='btn-drop-radio__item' key={metric}>
                    <TextPage
                        style={{ fontWeight: 600, minWidth: '100px' }}
                        text={metric.charAt(0).toUpperCase() + metric.slice(1)}
                    />

                    {/* Генерация радиокнопок для каждого варианта выбора */}
                    {options.map(option => (
                        <label className='btn-drop-radio__label' key={option}>
                            <input
                                type="radio"
                                name={metric}
                                value={option}
                                checked={checkboxValues?.[metric] === option}
                                onChange={() => handleRadioChange(metric, option)}
                                style={{ marginRight: '8px' }}
                            />
                            <TextPage
                                text={option.charAt(0).toUpperCase() + option.slice(1)}
                            />
                        </label>
                    ))}
                </div>
            ))}
        </>
    );
};

export default MetricControls;

const BtnDropRadio = ({ list, checkboxValues, setCheckboxValues }) => {

    const [isDrop, setIsDrop] = useState(false)

    // Обработчик на клик вне элемента,для закрытия блока с options
    useEffect(() => {
        const hideMenu = (e) => {
            let el = e.target
            if (!el.closest('.btn-drop-radio')) {
                setIsDrop(false)
            }
        }
        document.addEventListener('click', hideMenu)

        return () => {
            document.addEventListener('click', hideMenu)
        }
    }, [])

    return (
        <div className='btn-drop-radio'>
            <ButtonBasic
                grey
                className={'btn-drop-radio__btn'}
                text={<img src={settings_icon} />}
                minWidth='40px'
                width='40px'
                size='40px'
                onClick={(e) => setIsDrop(!isDrop)}
            />

            {isDrop && <div className='btn-drop-radio__drop-box'>
                <MetricControls
                    checkboxValues={checkboxValues}
                    setCheckboxValues={setCheckboxValues}
                />
            </div>}
        </div>
    )
}

export { BtnDropRadio }